<template>
  <div class="tw-flex tw-justify-center">
    <div class="tw-w-full xl:tw-w-4/5 lg:tw-w-11/12 tw-flex">
      <div
        class="tw-hidden lg:tw-block lg:tw-w-1/2 lg:tw-bg-cover lg:tw-bg-center"
        :style="{'background-image': 'url(' + require('@/assets/img/content/forms/dog-login.jpeg') + ')'}"
      />
      <div class="tw-w-full lg:tw-w-1/2 tw-p-5">
        <LoginForm />
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    LoginForm: () => import('@/components/forms/LoginForm'),
  },
};
</script>
